import React from 'react';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import './PhoneWithCountryInput.css';

/** Nigeria-first; users can change country in the selector. */
const DEFAULT_COUNTRY = 'NG';

/**
 * @param {object} props
 * @param {string} [props.id]
 * @param {string} [props.name]
 * @param {string} [props.value] E.164 or empty
 * @param {(v: string) => void} props.onChange
 * @param {'login' | 'book'} [props.variant]
 * @param {boolean} [props.disabled]
 * @param {boolean} [props.hasError]
 * @param {string} [props.placeholder]
 * @param {string} [props.autoComplete]
 */
export function PhoneWithCountryInput({
  id,
  name,
  value,
  onChange,
  variant = 'login',
  disabled,
  hasError,
  placeholder,
  autoComplete = 'tel',
  'aria-invalid': ariaInvalid,
  'aria-describedby': ariaDescribedBy,
}) {
  const rootClass = [
    'lux-phone-input',
    `lux-phone-input--${variant}`,
    hasError ? 'lux-phone-input--error' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={rootClass}>
      <PhoneInput
        id={id}
        name={name}
        international
        countryCallingCodeEditable={false}
        defaultCountry={DEFAULT_COUNTRY}
        value={value ? String(value) : undefined}
        onChange={(v) => onChange(v ?? '')}
        disabled={disabled}
        placeholder={placeholder}
        autoComplete={autoComplete}
        aria-invalid={ariaInvalid}
        aria-describedby={ariaDescribedBy}
        limitMaxLength
        smartCaret
      />
    </div>
  );
}
